module.exports = __webpack_public_path__ + "img/cobbl5.03f01c0a.jpeg";